export default __webpack_public_path__ + "static/media/049-puffer coat.4a151dc1.svg";